import { Expose } from 'class-transformer';
import { IsOptional, IsString } from 'class-validator';
import CustomIsNotEmpty from '../../../common/custom-class-validators/CustomIsNotEmpty';
import CustomLength from '../../../common/custom-class-validators/CustomLength';
import CustomMaxLength from '../../../common/custom-class-validators/CustomMaxLength';

export class CreateOrUpdateCategoryDto {
  @IsString()
  @CustomLength(3, 50, 'Name')
  @CustomIsNotEmpty('Name')
  @Expose()
  name: string;

  @IsOptional()
  @CustomMaxLength(255, 'Description')
  @Expose()
  description?: string;
}
